import React, { useContext, useEffect } from 'react'
import { UGE_GA_PREFIX } from '../../constants'
import { CreationToolsContext } from '../../manager'
import { CreationToolFrame } from '../../types'
import CreationToolOutputType from '../../types/output-type'
import SourceEditorModal from '../source-editor/modal'
import { SourceEditorEdits } from '../source-editor/types'
import { CreationToolUploadContext } from './manager'

const GA_CATEGORY = 'Upload'

const CreationUploadEditor = () => {
    const { trackEvent } = useContext(CreationToolsContext)
    const { editing, setEditing, updateUploadSource } = useContext(CreationToolUploadContext)

    const fireGAEvent = (action: string, value?: string) => {
        if (!editing) return

        const gaLabel = CreationToolOutputType.title(editing.source.outputType)
        trackEvent(GA_CATEGORY, `${UGE_GA_PREFIX}${action}`, gaLabel, value)
    }

    useEffect(() => {
        if (!editing) return

        fireGAEvent('Edit')
    }, [editing, fireGAEvent])

    if (!editing) {
        return null
    }

    const {
        source: { source, outputType, edits },
        defaultEditor,
    } = editing

    const onCancel = () => {
        setEditing(undefined)
    }

    const onDone = (sourceEdits?: SourceEditorEdits, frames?: CreationToolFrame[]) => {
        const updatedEdits =
            sourceEdits && frames
                ? { ...sourceEdits, watermarkUrl: frames[0].canvas.toDataURL('image/png', 1) }
                : sourceEdits

        // caption events
        if (updatedEdits?.captions && !edits?.captions) {
            const totalCaptions = updatedEdits.captions.length
            fireGAEvent('Add Caption', `${totalCaptions}`)
        }

        // crop events
        if (updatedEdits?.crop && !edits?.crop) {
            const aspectRatio = (updatedEdits.crop.width / updatedEdits.crop.height).toFixed(2)
            fireGAEvent('Crop', aspectRatio)
        }

        // trim events
        if (updatedEdits?.trim && !edits?.trim) {
            const duration = Math.round(updatedEdits.trim.end - updatedEdits.trim.start)
            fireGAEvent('Trim', `${duration}`)
        }

        updateUploadSource({ ...editing.source, edits: updatedEdits })
        setEditing(undefined)
    }

    return (
        <SourceEditorModal
            {...{
                source,
                edits,
                defaultEditor,
                outputType,
                onCancel,
                onDone,
            }}
        />
    )
}

export default CreationUploadEditor
